import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Constant from '@/constant/index'
import Utils from '@/utils/index'

Vue.use(VueI18n)
var currLang = Utils.getWithExpiry('userLang') || Utils.getCookie('user-lang') ||
  navigator.language || Constant.EN_US

currLang = currLang.includes('zh') ? 'zh-CN' : 'en-US'
const i18n = new VueI18n({
  locale: currLang,
  messages: {
    'zh-CN': require('@/assets/lang/zh'),
    'en-US': require('@/assets/lang/en')
  },
  silentTranslationWarn: true
})

export {
  i18n
}
